import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.navigation.Wrapper', null, 1);
        tmp0_serialDesc.a1b('value', false);
        this.gd7_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer().jd7(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static kd7() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.navigation.Wrapper', $this, 1);
        tmp0_serialDesc.a1b('value', false);
        $this.hd7_1 = tmp0_serialDesc;
        return $this;
      }
      ld7(encoder, value) {
        var tmp0_desc = this.hd7_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, this.id7_1, value.md7_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.ld7(encoder, value instanceof Wrapper() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.hd7_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.l13(tmp0_desc);
        if (tmp5_input.a14()) {
          tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, this.id7_1, tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.x13(tmp0_desc, 0, this.id7_1, tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp5_input.m13(tmp0_desc);
        return Wrapper().nd7(tmp3_bitMask0, tmp4_local0, null);
      }
      az() {
        return this.hd7_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.id7_1];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.id7_1];
      }
      static jd7(typeSerial0) {
        var $this = this.kd7();
        $this.id7_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var WrapperClass;
function Wrapper() {
  if (WrapperClass === VOID) {
    class $ {
      constructor(value) {
        Companion_getInstance();
        this.md7_1 = value;
      }
      toString() {
        return 'Wrapper(value=' + toString(this.md7_1) + ')';
      }
      hashCode() {
        return this.md7_1 == null ? 0 : hashCode(this.md7_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Wrapper()))
          return false;
        if (!equals(this.md7_1, other.md7_1))
          return false;
        return true;
      }
      static nd7(seen0, value, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance().gd7_1);
        }
        var $this = createThis(this);
        $this.md7_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'Wrapper', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    WrapperClass = $;
  }
  return WrapperClass;
}
//region block: exports
export {
  Wrapper as Wrapper2y18qo0rjxh4n,
  Companion_getInstance as Companion_getInstance3bmv1m2n6m7w7,
};
//endregion

//# sourceMappingURL=serialization.mjs.map
